import React, { useState, useCallback } from 'react';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import { useSelector } from 'react-redux';
import { useWindowSize } from 'react-use';

import { Drawer } from '@crm-framework/drawer';

import { getAppState, IStoreWithAppState } from '@crm-package/app';
import {
  NotificationBellContainer,
  NotificationHeader,
  Notifications,
} from '@crm-package/notifications';

import { MenuItem, StyledMenuIcon } from './styles';

export const getIsNotificationsEnabled = (state: IStoreWithAppState) => {
  const { config } = getAppState(state);

  return Boolean(config?.notificationPanelEnabled);
};

export const Bell: React.FC = React.memo(() => {
  const { width } = useWindowSize();
  const [isOpenNotifications, setIsOpenNotifications] = useState(false);

  const isNotificationsEnabled = useSelector(getIsNotificationsEnabled);

  const openNotifications = useCallback(() => {
    setIsOpenNotifications(true);
  }, []);

  const closeNotifications = useCallback(() => {
    setIsOpenNotifications(false);
  }, []);

  if (!isNotificationsEnabled) {
    return null;
  }

  return (
    <>
      <MenuItem>
        <StyledMenuIcon onClick={openNotifications}>
          <NotificationBellContainer />
        </StyledMenuIcon>
      </MenuItem>
      <Drawer
        name="notificationDrawerWidth"
        classNamePrefix="notifications-drawer"
        appearance="right-border-drawer"
        width={800}
        maxWidth={width - 350}
        minWidth={500}
        isOpen={isOpenNotifications}
        closeIconComponent={<ArrowLeftIcon />}
        isRTL={false}
        isMovable
        title={<NotificationHeader />}
        onClose={closeNotifications}>
        <Notifications />
      </Drawer>
    </>
  );
});
